import React from 'react';
import styled from '@emotion/styled';

import Activity from './Activity';

const List = styled.ul`
  list-style-type: none;
  padding: ${props => props.theme.size.large};
`;

export default function ActivityList(props) {
  return (
    <List>
      {props.activities &&
        props.activities.map(activity => (
          <Activity
            activityIndex={props.activityIndex}
            activity={activity}
            key={activity.title}
            addTimelineEntry={props.addTimelineEntry}
            removeActivity={props.removeActivity}
            removeLastEntry={props.removeLastEntry}
          />
        ))}
    </List>
  );
}
